const emailForm = {
  username: [{
    rule: 'required',
    error: 'Username is required',
  }],
};

export default emailForm;
